import React from 'react'

const PageHeader = ({ title }) => {
    return (
        <span style={{ width: '100%', fontSize: '41px', margin: '25px 0px 25px 0px' }}>{title}</span>
    )
}

export default PageHeader